document.addEventListener("DOMContentLoaded", function () {
  const siteHeader = document.getElementById('SiteHeader');
  const sectionHero = document.getElementById('sectionHero');

  const cartDrawer = document.getElementById('slideCart');
  const cartDrawerOverlay = document.getElementById('slideCartOverlay');
  const openCartBtn = document.getElementById('HeaderCartTrigger');
  const closeCartBtn = document.getElementById('closeCart');
  const cartItemsContainer = document.getElementById('cartItems');
  const cartSubtotal = document.getElementById('cartSubtotal');
  const freeShippingMsg = document.getElementById('freeShippingMsg');
  const progress = document.getElementById('progress');
  const cartCheckout = document.getElementById('checkoutBtn');

  const FREE_SHIPPING_THRESHOLD = 50;

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function fetchCart() {
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      renderCartItems(cart.items);
      updateSubtotal(cart.total_price);
      updateCartCount(cart);
    });
  }

  function calculateItemDiscounts(items) {
    let totalDiscount = 0;
    items.forEach(item => {
      const itemDiscount = item.original_line_price - item.line_price;
      totalDiscount += itemDiscount;
    });
    return totalDiscount;
  }

  function updateSubtotal(priceInCents) {
    const subtotal = (priceInCents / 100).toFixed(2);
    cartSubtotal.textContent = `$${subtotal} USD`;
    const amountLeft = (FREE_SHIPPING_THRESHOLD - priceInCents / 100).toFixed(2);
    const percent = Math.min(100, ((priceInCents / 100) / FREE_SHIPPING_THRESHOLD) * 100);
    freeShippingMsg.innerHTML  = amountLeft > 0
    ? `You're $${amountLeft} away from <b>Free 2 Day Expedited</b>`
    : `Congratulations! You've unlocked <b>Free 2 Day Expedited</b>`;
    progress.style.width = percent + "%";
  }

  function renderCartItems(items) {
    cartItemsContainer.innerHTML = '';
    items.forEach(item => {
      const div = document.createElement('div');
      const originalPrice = formatMoney(item.original_line_price);
      const currentPrice = formatMoney(item.line_price);
      const hasDiscount = item.original_line_price > item.line_price;
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : null;

      div.innerHTML = `
        <div class="cart-line-item" data-key="${item.key}">
          <div class="cli-img">
            <img src="${item.image}"
              alt="item" width="100%" height="97px">
          </div>
          <div class="cli-content">
            <a href="#" class="cli-title">${item.product_title}</a>
            <p class="cli-price">
              ${hasDiscount ? `<span>${originalPrice}</span>` : ''}
              ${currentPrice} USD
            </p>
            ${variantTitle ? `<p class="cli-variant">Variant: ${variantTitle}</p>` : ''}
            <div class="cli-cta">
                <div class="cli-qty">
                  <a href="#" class="cli-btn-qty" data-action="decrease">-</a>
                  <input type="number"
                    class="cli-input-qty"
                    min="1"
                    value="${item.quantity}"
                    placeholder="1" readonly>
                  <a href="#" class="cli-btn-qty" data-action="increase">+</a>
                </div>
                <a href="#" class="cli-delete">
                  <img src="//cdn.shopify.com/s/files/1/0756/8805/0968/files/delete.png?v=1751053540"
                    alt="item" width="16px" height="16px">
                </a>
              </div>
            </div>
        </div>`;
      cartItemsContainer.appendChild(div);
    });
    attachCartEventListeners();
  }

  function attachCartEventListeners() {
    document.querySelectorAll(".cli-btn-qty").forEach(btn => {
      btn.addEventListener("click", function () {
        const action = btn.dataset.action;
        const cartItem = btn.closest(".cart-line-item");
        const input = cartItem.querySelector(".cli-input-qty");
        const currentQty = parseInt(input.value, 10);
        const newQty = action === "increase" ? currentQty + 1 : currentQty - 1;
        const key = cartItem.dataset.key;

        updateQuantity(key, newQty);
      });
    });

    document.querySelectorAll(".cli-delete").forEach(btn => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        const cartItem = btn.closest(".cart-line-item");
        const key = cartItem.dataset.key;
        updateQuantity(key, 0); // Triggers removal
      });
    });
  }

  function updateQuantity(key, quantity) {
    if (quantity < 1) {
      removeFromCart(key);
      return;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      updateCartUI();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
  }

  function removeFromCart(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(data => {
      updateCartUI();
    })
    .catch(error => {
      console.error('Error removing from cart:', error);
    });
  }

  function updateCartUI() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart count in drawer
        const cartCount = document.getElementById('cartItemCount');
        if (cartCount) {
          cartCount.textContent = `(${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'})`;
        }

        // Update cart count in trigger button
        const cartTriggerCount = document.getElementById('cartTriggerCount');
        if (cartTriggerCount) {
          cartTriggerCount.textContent = cart.item_count;
        }

        // Update cart total
        const cartSubtotal = document.getElementById('cartSubtotal');
        if (cartSubtotal) {
          cartSubtotal.textContent = formatMoney(cart.total_price);
        }

        // Reload the page to update cart items display
        location.reload();
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  function updateCartCount(cart) {
    const totalItems = cart.items.reduce((sum, item) => sum + item.quantity, 0);
    const label = totalItems === 1 ? 'item' : 'items';
    document.getElementById("cartTriggerCount").textContent = `(${totalItems} ${label})`;
  }

  // openCartBtn.onclick = (e) => {
  //   e.preventDefault();
  //   cartDrawer.classList.add("open");
  //   cartDrawerOverlay.classList.add("open");
  // };

  cartCheckout.onclick = (e) => {
    e.preventDefault();
    window.location.href = '/checkout';
  };

  closeCartBtn.onclick = () => {
    cartDrawer.classList.remove("open");
    cartDrawerOverlay.classList.remove("open");
  }

  cartDrawerOverlay.onclick = () => {
    cartDrawer.classList.remove("open");
    cartDrawerOverlay.classList.remove("open");
  }

  document.querySelectorAll('.cli-qty').forEach(function (qtyWrapper) {
    qtyWrapper.addEventListener('click', function (e) {
      if (e.target.classList.contains('cli-btn-qty')) {
        e.preventDefault(); // prevent <a> default behavior

        const input = qtyWrapper.querySelector('.cli-input-qty');
        let value = parseInt(input.value) || 1;
        const min = parseInt(input.getAttribute('min')) || 1;

        if (e.target.dataset.action === 'increase') {
          value++;
        } else if (e.target.dataset.action === 'decrease') {
          value = value > min ? value - 1 : min;
        }

        input.value = value;
        input.dispatchEvent(new Event("change")); // trigger change event
      }
    });
  });

  document.querySelectorAll('.cli-input-qty').forEach(function (input) {
    input.addEventListener('change', function () {
      console.log("Quantity changed to", input.value);
      // update totals, trigger ajax, etc.
    });
  });

  // Load on open
  // openCartBtn.addEventListener('click', fetchCart);

  window.addEventListener('load', function () {
    document.querySelectorAll('.card_bottom_hover').forEach(function (el) {
      const cbh_item = el.querySelector('.cbh_item');
      if (cbh_item && cbh_item.offsetWidth >= el.offsetWidth) {
        cbh_item.classList.add('scrollTextAni');
      }
    });
  });

  if (siteHeader && sectionHero) {
    const headerHeight = siteHeader.offsetHeight;
    sectionHero.style.paddingTop = `${headerHeight}px`;
  }

  // const scrollBlock = document.querySelector('.services-block-scroll');
  // const clone = scrollBlock.cloneNode(true);
  // scrollBlock.parentElement.appendChild(clone);

  const productVideoOverlay = document.getElementById('productVideoOverlay');
  const productVideoModal = document.getElementById('productVideoModal');
  productVideoOverlay.onclick = () => {
    productVideoModal.classList.remove("show");
    productVideoOverlay.classList.remove("open");
  }

  const interval = setInterval(() => {
    const target = document.querySelector('.best-fit-size-chart');

    if (target) {
      const hasExistingBtn = target.querySelector('.scr-open-size-chart');
      const hasNewBtn = target.querySelector('.btn-video');

      // Proceed only if existing button is already there and new one isn't
      if (hasExistingBtn && !hasNewBtn) {
        const newButton = document.createElement('button');
        newButton.className = 'btn-video';
        newButton.textContent = 'Watch How Its Made';

        // Create FAQ link
        const faqSection = document.querySelector('[id^="shopify-section"][id*="faq"]');
        const newFAQ = document.createElement('a');
        newFAQ.className = 'btn-faq';
        newFAQ.textContent = 'FAQ';
        if (faqSection) {
          newFAQ.href = `#${faqSection.id}`;
        }

        newButton.addEventListener('click', () => {
          document.getElementById('productVideoModal').classList.add('show');
          document.getElementById('productVideoOverlay').classList.add('open');
        });

        // Append without removing anything
        target.appendChild(newButton);
        target.appendChild(newFAQ);
      }

      // Stop checking once both buttons are present
      if (hasExistingBtn && target.querySelector('.btn-video')) {
        clearInterval(interval);
      }
    }
  }, 1000);

  document.querySelectorAll('.btn-theme-customize-now').forEach(button => {
    button.addEventListener('click', function(e) {
        e.preventDefault();
        const swatchButton = document.querySelector('.cl-po--swatch-button');
        if (swatchButton) swatchButton.click();
      });
  });

  // Sticky functionality for shopdev-promotion section
  function initStickyPromotion() {
    const promotionSection = document.querySelector('[id*="shopdev_promotion"]');
    const footer = document.querySelector('[id*="text_with_icons"]');

    if (!promotionSection) {
      console.log('Promotion section not found');
      return;
    }

    let isSticky = false;
    const originalPosition = promotionSection.offsetTop;
    const stickyClass = 'show';

    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const promoHeight = promotionSection.offsetHeight;
      let footerTop = null;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        footerTop = footerRect.top + window.pageYOffset;
      }

      // Only show if scrolled past original position and not overlapping footer
      if (
        scrollTop > originalPosition &&
        (!footerTop || (scrollTop + promoHeight < footerTop))
      ) {
        if (!isSticky) {
          promotionSection.classList.add(stickyClass);
          isSticky = true;
        }
      } else {
        if (isSticky) {
          promotionSection.classList.remove(stickyClass);
          isSticky = false;
        }
      }
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    handleScroll();
  }

  // Initialize sticky promotion when DOM is ready
  initStickyPromotion();

  const btnHowItsMade = document.querySelector('.btn-how-its-made');
  btnHowItsMade.addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('productVideoModal').classList.add('show');
    document.getElementById('productVideoOverlay').classList.add('open');
  });
});
